/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import API from 'api';
// eslint-disable-next-line no-restricted-imports
import { Noun, Verb } from 'common/debug/analytics-constants';
// eslint-disable-next-line no-restricted-imports
import Analytics from 'debug/analytics';
// eslint-disable-next-line no-restricted-imports
import {
  ANNOUNCEMENTS_REQUEST,
  ANNOUNCEMENTS_SUCCESS,
  AnnouncementsRequestAction,
  AnnouncementsSuccessAction,
} from 'modules/loaders';
// eslint-disable-next-line no-restricted-imports
import { AnnouncementResponse, StandardThunkAction } from 'types';
// eslint-disable-next-line no-restricted-imports
import { Action, actionCreator } from 'util/actions';
// eslint-disable-next-line no-restricted-imports
import { markRead } from 'util/application-storage/announcements';
// eslint-disable-next-line no-restricted-imports
import { createReducer } from 'util/reducers';

// Action types
export const ANNOUNCEMENT_DISMISS_REQUEST = Symbol(
  'loaders/ANNOUNCEMENT_DISMISS_REQUEST',
);
export const ANNOUNCEMENT_DISMISS_SUCCESS = Symbol(
  'loaders/ANNOUNCEMENT_DISMISS_SUCCESS',
);
export const ANNOUNCEMENT_DISMISS_ERROR = Symbol(
  'loaders/ANNOUNCEMENT_DISMISS_ERROR',
);

export type AnnouncementRequestAction = Action<
  typeof ANNOUNCEMENT_DISMISS_REQUEST,
  { id: string }
>;
export type AnnouncementSuccessAction = Action<
  typeof ANNOUNCEMENT_DISMISS_SUCCESS,
  null
>;
export type AnnouncementErrorAction = Action<
  typeof ANNOUNCEMENT_DISMISS_ERROR,
  Error
>;

// Action creators
const announcementDismissRequest = actionCreator<AnnouncementRequestAction>(
  ANNOUNCEMENT_DISMISS_REQUEST,
);
const announcementDismissSuccess = actionCreator<AnnouncementSuccessAction>(
  ANNOUNCEMENT_DISMISS_SUCCESS,
);
const announcementDismissError = actionCreator<AnnouncementErrorAction>(
  ANNOUNCEMENT_DISMISS_ERROR,
);

export interface AnnouncementsState {
  loading: boolean;
  collection: {
    [announcementId: string]: AnnouncementResponse;
  };
}

const upsertAnnouncement = (
  state: AnnouncementsState,
  announcement: AnnouncementResponse,
): AnnouncementsState => ({
  ...state,
  collection: {
    ...state.collection,
    [announcement.id]: {
      ...(state.collection[announcement.id] || {}),
      ...announcement,
    },
  },
});

// Reducer
const initialState: AnnouncementsState = {
  loading: false,
  collection: {},
};

export default createReducer(initialState, {
  [ANNOUNCEMENTS_REQUEST](state, { payload }: AnnouncementsRequestAction) {
    return {
      ...state,
      loading: true,
    };
  },
  [ANNOUNCEMENTS_SUCCESS](state, { payload }: AnnouncementsSuccessAction) {
    return {
      loading: false,
      ...payload.reduce(
        (result, announcement) => upsertAnnouncement(result, announcement),
        state,
      ),
    };
  },
});

export const dismissAnnouncement = (id: string): StandardThunkAction => {
  return async (dispatch, getState) => {
    try {
      dispatch(announcementDismissRequest({ id }));

      markRead(id);
      await API.client.dismissAnnouncement(id);

      dispatch(announcementDismissSuccess());

      Analytics.trackUE({
        category: Noun.ANNOUNCEMENTS,
        verb: Verb.DISMISSES,
        directObj: Noun.ANNOUNCEMENTS,
      });
    } catch (err) {
      dispatch(announcementDismissError(err));
    }
  };
};



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/models/announcements.ts